/**
 * Cart Icon — listens for cart events and updates the "Panier (X)" count.
 */
import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class CartIcon extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const opts = { signal: this.#controller.signal };

    // After a quantity change / remove, we get the full cart object
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate, opts);

    // After an add, the response is the items added — refetch full cart
    document.addEventListener(ThemeEvents.cartAdd, this.#onCartAdd, opts);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #onCartUpdate = (event) => {
    const cart = event.detail?.resource;
    if (cart) this.#updateCount(cart.item_count ?? 0);
  };

  #onCartAdd = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (res.ok) {
        const cart = await res.json();
        this.#updateCount(cart.item_count ?? 0);
      }
    } catch { /* silent */ }
  };

  #updateCount(count) {
    // "Panier (X)" text count
    const text = this.querySelector('.cart-count');
    if (text) text.textContent = count;

    // Floating bubble (hidden via CSS, but kept in sync if re-enabled)
    const bubble = this.querySelector('[data-cart-count]');
    if (bubble) {
      bubble.textContent = count;
      bubble.classList.toggle('cart-bubble--hidden', count === 0);
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
